import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getOnlyToken, ConfirmationAlert } from "../utils/commonFunctions";

export default function Integrations() {
  const navigate = useNavigate();
  const [functions, setFunctions] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Fetch Custom Functions (same pattern you use)
  const fetchCustomFunctions = async () => {
    try {
      setLoading(true);
      const token = getOnlyToken();
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const res = await axios.get(
        "api/agents/custom-functions/create/",
        config
      );

      if (res.status === 200) {
        setFunctions(res.data.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch integrations", error);
      setFunctions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomFunctions();
  }, []);

  // 🔹 Actions
  const handleEdit = (row) => {
    navigate('/create-integration', { state: { editId: row.id } });
  };

  const handleDelete = (row) => {
    ConfirmationAlert(
      `Do you want to delete "${row.function_name}"?`,
      "Yes, Delete",
      async () => {
        try {
          const token = getOnlyToken();
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
          await axios.delete(`/api/agents/custom-functions/create/?id=${row.id}`, config);
          fetchCustomFunctions();
        } catch (error) {
          console.error("Failed to delete integration", error);
        }
      }
    );
  };

  // 🔹 Table Columns
  const columns = [
    {
      name: "S.No",
      width: "80px",
      cell: (row, index) => index + 1,
    },
    {
      name: "Function Name",
      selector: (row) => row.function_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Description",
      selector: (row) => row.function_description,
      wrap: true,
    },
    {
      name: "URL Type",
      wrap: true,
      center:true,
      cell: (row) => (row.url_type === "GET" ? (<span className="badge bg-success">GET</span>) : (<span className="badge bg-primary">POST</span>)
      ),
    },
    {
      name: "URL",
      wrap: true,
      cell: (row) =>
        row.url ? (
          <a
            href={row.url}
            target="_blank"
            rel="noreferrer"
            className="text-primary text-decoration-none"
          >
            {row.url}
          </a>
        ) : (
          "-"
        ),
    },
    {
  name: "Actions",
  width: "150px",
  center: true,
  cell: (row) => (
    <div className="d-flex gap-2 justify-content-center">
      {/* Edit */}
      <button
        className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary"
        title="Edit"
        onClick={() => handleEdit(row)}
        style={{
          width: 34,
          height: 34,
          backgroundColor: "#7b99b1ff",
          color: "#fff",
        }}
      >
        <i className="bi bi-pencil"></i>
      </button>

      {/* Delete */}
      <button
        className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary"
        title="Delete"
        onClick={() => handleDelete(row)}
        style={{
          width: 34,
          height: 34,
          backgroundColor: "#ee8080ff",
          color: "#fff",
        }}
      >
        <i className="bi bi-trash"></i>
      </button>
    </div>
  ),
}

  ];

   const customStyles = {
    table: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#FFFFFF",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#2b3544ff",
        borderBottom: "1px solid rgb(70,79,91)",
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        fontSize: "14px",
        fontWeight: 600,
        borderRight: "1px solid rgb(70,79,91)",
      },
    },
    rows: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#fff",
        minHeight: "48px",
        "&:hover": {
          backgroundColor: "#23263A",
        },
      },
    },
    cells: {
      style: {
        borderBottom: "1px solid rgb(70,79,91)",
        fontSize: "14px",
        color: "#E1E1E1",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#FFFFFF",
        borderTop: "1px solid rgb(70,79,91)",
      },
      pageButtonsStyle: {
        color: "#FFFFFF !important",
        fill: "#FFFFFF !important",
        "&:hover": {
          backgroundColor: "#2A2D3F",
        },
        "&:disabled": {
          color: "#777 !important",
          fill: "#777 !important",
        },
      },
    },

    noData: {
      style: {
        backgroundColor: "transparent",
        color: "#fff",
        padding: "20px",
      },
    },
  };


  return (
    <div className="container-fluid py-4">
      {/* ===== Header ===== */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-success mb-0">
          Custom Integrations
        </h2>

        <button
          onClick={() => navigate('/create-integration')}
          className="btn btn-primary  d-flex fs-6 align-items-center gap-1 px-2"
        >
            <i className="bi bi-plus fs-5"></i>
          Add Integration
        </button>
      </div>

      {/* ===== Data Table ===== */}
      <div className="card">
        <DataTable
          columns={columns}
          data={functions}
          progressPending={loading}
          progressComponent={
            <div className="d-flex flex-column align-items-center justify-content-center py-5 bg-black w-100" style={{ minHeight: '400px' }}>
              <div className="spinner-border text-success" role="status"></div>
            </div>
          }
          customStyles={customStyles}
          pagination
          responsive
          persistTableHead
          noDataComponent={
            <div className="py-4 text-muted">
              No integrations found
            </div>
          }
        />
      </div>
    </div>
  );
}
